import FaqsAppConfig from './faqs/FaqsAppConfig';
import ThemeAppConfig from './theme/ThemeAppConfig';
import NavigationsAppConfig from './navigations/NavigationsAppConfig';
import FooterAppConfig from './footer/FooterAppConfig';
import PagesAppConfig from './pages/PagesAppConfig';
import HeaderAppConfig from './header/HeaderAppConfig';
import CartSettingsAppConfig from '@ameroservices-platform/attraction-backend/app/main/apps/frontendSettings/cartSettings/CartSettingsAppConfig';
import InformationFormsAppConfig from '@ameroservices-platform/attraction-backend/app/main/apps/frontendSettings/informationForms/InformationFormsAppConfig';
import GeneralSettingsAppConfig from '@ameroservices-platform/attraction-backend/app/main/apps/frontendSettings/generalSettings/GeneralSettingsAppConfig';

const appsConfigs = [
	FaqsAppConfig,
	ThemeAppConfig,
	NavigationsAppConfig,
	FooterAppConfig,
	HeaderAppConfig,
	PagesAppConfig,
	CartSettingsAppConfig,
	InformationFormsAppConfig,
	GeneralSettingsAppConfig
];

export default appsConfigs;
